// HACK: You might read this and think "wait ... this is just navigating when an
// element is clicked that has an href, shouldn't that always happen?"
// And you'd be correct! The version of react-big-calendar somehow breaks a
// simple <a href> when clicking on them from the "show more" button.
// We use portals for that, so it shouldn't even be caught by errant event
// handlers.

const reactBigCalendarLinkHack: React.MouseEventHandler = (event) => {
  if (event.target instanceof HTMLElement) {
    const href = event.target.getAttribute('href')
    if (href) {
      window.location.href = href
    }
  }
}

export default reactBigCalendarLinkHack
